export interface AttributionTypeDTO {
  id: string;
  name: string;
  status: statusEnum;
}

export enum statusEnum {
  X = 'X',
  N = 'N',
  P = 'P',
}

export interface ProfileDTO {
  id?: string;
  name: string;
  typeBank: bankStatusEnum;
  attributions: AttributionTypeDTO[];
}

export enum bankStatusEnum {
  'S',
  'N',
}
